import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Globe, Network, FileText, Upload, Database, Plug, X } from 'lucide-react'
import { Logo } from './Integrations'
import ContentSource from './ContentSource'

// A click-to-connect grid: real logos; click one → a modal with just that
// connector's fields (Test + Connect). Content types (website/file/text) open
// the matching ContentSource tab. Reused wherever a source can be added.
const ITEMS = [
  { key: 'url', name: 'Website', kind: 'content', icon: Globe },
  { key: 'sitemap', name: 'Sitemap', kind: 'content', icon: Network },
  { key: 'text', name: 'Paste text', kind: 'content', icon: FileText },
  { key: 'file', name: 'Upload file', kind: 'content', icon: Upload },
  { key: 'sql', name: 'SQL database', icon: Database },
  { key: 's3', name: 'AWS S3', slug: 'amazonwebservices' },
  { key: 'gcs', name: 'Google Cloud', slug: 'googlecloud' },
  { key: 'azure', name: 'Azure Blob', slug: 'microsoftazure' },
  { key: 'confluence', name: 'Confluence', slug: 'confluence' },
  { key: 'jira', name: 'Jira', slug: 'jira' },
  { key: 'monday', name: 'monday.com', icon: Database },
  { key: 'asana', name: 'Asana', slug: 'asana' },
  { key: 'salesforce', name: 'Salesforce', slug: 'salesforce' },
  { key: 'sap', name: 'SAP', slug: 'sap' },
  { key: 'slack', name: 'Slack', slug: 'slack' },
]

export default function ConnectorGrid({ dataInstanceId, instanceId, onDone }) {
  const [open, setOpen] = useState(null)
  const [catalog, setCatalog] = useState([])
  useEffect(() => { axios.get('/api/v1/sync/connectors/catalog').then(r => setCatalog(r.data.connectors || [])).catch(() => {}) }, [])
  // Config-driven systems auto-appear as tiles (Custom REST/OData included).
  const items = [...ITEMS, ...catalog.map((c) => ({ key: c.id, name: c.name, icon: c.id.startsWith('custom') ? Database : Plug }))]
  return (
    <>
      <div className="grid grid-cols-3 sm:grid-cols-5 gap-3">
        {items.map((it) => {
          const Icon = it.icon
          return (
            <button key={it.key} onClick={() => setOpen(it)}
              className="flex flex-col items-center gap-2 p-3 rounded-xl border border-gray-200 bg-white hover:border-primary-300 hover:shadow-sm transition-all">
              <span className="w-9 h-9 flex items-center justify-center text-gray-500">
                {it.slug ? <Logo slug={it.slug} size={26} /> : <Icon size={22} />}
              </span>
              <span className="text-[11px] text-gray-600 text-center leading-tight">{it.name}</span>
            </button>
          )
        })}
      </div>

      {open && (
        <div className="fixed inset-0 z-40 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <div className="absolute inset-0 bg-black/40" />
          <div className="relative w-full max-w-lg bg-white rounded-2xl border border-gray-200 shadow-xl p-6 max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                {open.slug ? <Logo slug={open.slug} size={22} /> : (open.icon && <open.icon size={18} className="text-gray-500" />)}
                Connect {open.name}
              </h3>
              <button onClick={() => setOpen(null)} className="text-gray-400 hover:text-gray-700"><X size={18} /></button>
            </div>
            <ContentSource
              dataInstanceId={dataInstanceId} instanceId={instanceId}
              initialTab={open.kind === 'content' ? open.key : undefined}
              soloProvider={open.kind === 'content' ? undefined : open.key}
              onDone={() => { onDone?.(); setOpen(null) }} />
          </div>
        </div>
      )}
    </>
  )
}
